import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import Buefy from 'buefy'

Vue.config.productionTip = false

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Buefy, {
    defaultIconComponent: "font-awesome-icon",
    defaultIconPack: "fas"
})


new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
